export default "__VITE_ASSET__e858697a__"